export const checkLezzooDomain = (message) => {
  const imageReg = /[\/@](lezzoo)/i;
  return imageReg.test(message);
};
